import { InputWithOptionsUniDriver } from '../InputWithOptions/InputWithOptions.uni.driver';

export { inputWithOptionsUniDriverFactory as autoCompleteUniDriverFactory } from '../InputWithOptions/InputWithOptions.uni.driver';

export interface AutoCompleteUniDriver extends InputWithOptionsUniDriver {}
